import { Server } from './Server';
import { FetchServer } from './FetchServer';
import { Collection } from './Collection';
import { Single } from './Single';

export { Server, FetchServer, Collection, Single };
export default { Server, FetchServer, Collection, Single };
